document.addEventListener("DOMContentLoaded", function () {
  // Insert the necessary CSS for auto-scaling and responsiveness into the document
  document.addEventListener("DOMContentLoaded", function () {
  // Insert the necessary CSS for auto-scaling and responsiveness into the document
  const style = document.createElement("style");
  style.textContent = `
    .container {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: wrap;
      width: 100%;
    }

    .table-container {
      flex: 1;
      min-width: 40%;
      width: 100%;
      overflow-x: auto; /* Allow scrolling on small screens if needed */
    }

    .image-container {
      width: 20%;
      max-width: 150px; /* Prevent the image from getting too big */
      min-width: 80px; /* Prevent the image from becoming too small */
      height: auto;
      margin-left: 2vw; /* Dynamically adjust margin based on viewport width */
    }

    /* Ensure the table is responsive */
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 2vw; /* Dynamic font size based on viewport width */
    }

    th, td {
      padding: 1vw; /* Dynamic padding */
      text-align: center;
      border: 1px solid #ccc;
    }

    /* Media Queries for fine-tuning on smaller screens */
    @media (max-width: 768px) {
      .image-container {
        max-width: 120px; /* Adjust image size on smaller screens */
        min-width: 60px;
      }

      th, td {
        font-size: 2vw; /* Make the text a little larger on mobile */
      }
    }

    @media (max-width: 480px) {
      th, td {
        font-size: 3vw; /* Further increase font size on very small screens */
        padding: 1.5vw;
      }

      .image-container {
        max-width: 100px;
      }
    }
  `;
  document.head.appendChild(style);

  // Energizer data for each option
  const energizerData = {
    // Your energizer data goes here
  };

  const colorMap = [
    { min: 0, max: 999, color: "#FFFF99" }, // Light yellow
    { min: 1000, max: 2599, color: "#FFCC66" }, // Light orange
    { min: 2600, max: 3599, color: "#FF9933" }, // Orange
    { min: 3600, max: 4499, color: "#FF6600" }, // Dark orange
    { min: 4500, max: Infinity, color: "#FF3300" }, // Red
  ];

  const imageMap = [
    { min: 0, max: 999, src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-01.png" },
    { min: 1000, max: 2599, src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-02.png" },
    { min: 2600, max: 3599, src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-03.png" },
    { min: 3600, max: 4499, src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-04.png" },
    { min: 4500, max: Infinity, src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-05.png" },
  ];

  const tableContainer = document.getElementById("heatmap-table");
  const imageDisplay = document.getElementById("image-display");
  const dropdown = document.getElementById("energizer-select");

  let inactivityTimeout; // Variable to store the inactivity timer
  let currentImageIndex = 0; // Track current image index

  // Function to get color based on voltage (stays as it is)
  function getColor(voltage) {
    for (let range of colorMap) {
      if (voltage >= range.min && voltage <= range.max) {
        return range.color;
      }
    }
    return "#FFFFFF"; // Default color (white) if no match
  }

  // Function to get image based on voltage (stays as it is)
  function getImage(voltage) {
    for (let range of imageMap) {
      if (voltage >= range.min && voltage <= range.max) {
        return range.src;
      }
    }
    return "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-06.png"; // Skull image for unmatched values
  }

  // Function to create or update the table (stays as it is)
  function createTable(selectedData) {
    tableContainer.innerHTML = ""; // Clear the previous table
    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.borderCollapse = "collapse";

    // Create the header row
    const headerRow = document.createElement("tr");
    const headers = ["Distance", "5 mil", "7 mil", "9 mil", "10 mil", "12 mil"];
    headers.forEach((headerText) => {
      const th = document.createElement("th");
      th.textContent = headerText;
      th.style.padding = "10px";
      th.style.textAlign = "center";
      th.style.backgroundColor = "#DFF0D8";
      th.style.border = "0px solid #ccc";
      headerRow.appendChild(th);
    });
    table.appendChild(headerRow);

    // Populate the table with the selected data
    selectedData.rows.forEach((rowData) => {
      const row = document.createElement("tr");
      rowData.forEach((cellData, index) => {
        const td = document.createElement("td");
        td.textContent = cellData;
        td.style.padding = "10px";
        td.style.textAlign = "center";
        td.style.border = "0px solid #ccc";

        // Assign color based on voltage for non-skull cells
        if (cellData !== "☠️" && !isNaN(cellData)) {
          const voltage = parseInt(cellData);
          td.style.backgroundColor = getColor(voltage);

          // Add hover and touch events to change the image
          td.addEventListener("mouseover", () => {
            clearTimeout(inactivityTimeout); // Clear previous inactivity timer
            imageDisplay.src = getImage(voltage);
            currentImageIndex = imageMap.findIndex((range) => getImage(voltage) === range.src);
            resetInactivityTimer();
          });
          td.addEventListener("touchstart", () => {
            clearTimeout(inactivityTimeout); // Clear previous inactivity timer
            imageDisplay.src = getImage(voltage);
            currentImageIndex = imageMap.findIndex((range) => getImage(voltage) === range.src);
            resetInactivityTimer();
          });
        } else if (cellData === "☠️") {
          td.style.backgroundColor = "#FFFFFF"; // Keep skull cells white
          td.style.color = "black"; // Skull symbol always visible
          td.addEventListener("mouseover", () => {
            clearTimeout(inactivityTimeout); // Clear previous inactivity timer
            imageDisplay.src = "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-06.png";
            resetInactivityTimer();
          });
          td.addEventListener("touchstart", () => {
            clearTimeout(inactivityTimeout); // Clear previous inactivity timer
            imageDisplay.src = "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-06.png";
            resetInactivityTimer();
          });
        }

        row.appendChild(td);
      });
      table.appendChild(row);
    });

    tableContainer.appendChild(table);
  }

  // **NEW CODE: Function to reverse images in sequence**
  function reverseImages() {
    if (currentImageIndex > 0) {
      currentImageIndex--;
      imageDisplay.src = imageMap[currentImageIndex].src;
      setTimeout(reverseImages, 500); // Adjust speed as necessary
    }
  }

  // **NEW CODE: Function to reset inactivity timer**
  function resetInactivityTimer() {
    clearTimeout(inactivityTimeout); // Clear any previous timer
    inactivityTimeout = setTimeout(() => {
      reverseImages(); // Start reversing images after 7 seconds of inactivity
    }, 7000); // Start the countdown after 7 seconds
  }

  // Event listener for dropdown selection (remains unchanged)
  dropdown.addEventListener("change", function () {
    const selectedOption = dropdown.value;
    const selectedData = energizerData[selectedOption];
    createTable(selectedData);
  });

  // Initialize with the 2 Mile data
  createTable(energizerData["2 Mile"]);

  // Start the inactivity timer when the page is loaded
  resetInactivityTimer();
});
const style = document.createElement("style");
  style.textContent = `
    .container {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: wrap;
      width: 100%;
    }

    .table-container {
      flex: 1;
      min-width: 40%;
      width: 100%;
      overflow-x: auto; /* Allow scrolling on small screens if needed */
    }

    .image-container {
      width: 20%;
      max-width: 150px; /* Prevent the image from getting too big */
      min-width: 80px; /* Prevent the image from becoming too small */
      height: auto;
      margin-left: 2vw; /* Dynamically adjust margin based on viewport width */
    }

    /* Ensure the table is responsive */
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 2vw; /* Dynamic font size based on viewport width */
    }

    th, td {
      padding: 1vw; /* Dynamic padding */
      text-align: center;
      border: 1px solid #ccc;
    }

    /* Media Queries for fine-tuning on smaller screens */
    @media (max-width: 768px) {
      .image-container {
        max-width: 120px; /* Adjust image size on smaller screens */
        min-width: 60px;
      }

      th, td {
        font-size: 2vw; /* Make the text a little larger on mobile */
      }
    }

    @media (max-width: 480px) {
      th, td {
        font-size: 3vw; /* Further increase font size on very small screens */
        padding: 1.5vw;
      }

      .image-container {
        max-width: 100px;
      }
    }
  `;
  document.head.appendChild(style);

  // Energizer data for each option
  const energizerData = {
    "2 Mile": {
      rows: [
        [2, 4000, 4150, 4300, 4400, 4550],
        [5, 1900, 2200, 2450, 2550, 2700],
        [10, 750, 950, 1200, 1300, 1500],
        [25, "☠️", "☠️", "☠️", "☠️", "☠️"],
        [50, "☠️", "☠️", "☠️", "☠️", "☠️"],
        [100, "☠️", "☠️", "☠️", "☠️", "☠️"],
        [200, "☠️", "☠️", "☠️", "☠️", "☠️"],
      ],
    },
    "5 Mile": {
      rows: [
        [2, 4500, 4600, 4700, 4800, 4950],
        [5, 3800, 3900, 4000, 4150, 4350],
        [10, 1900, 2200, 2400, 2700, 3300],
        [25, 500, 700, 1000, 1300, 1900],
        [50, "☠️", "☠️", 200, 400, 1000],
        [100, "☠️", "☠️", "☠️", "☠️", "☠️"],
        [200, "☠️", "☠️", "☠️", "☠️", "☠️"],
      ],
    },
    "10 Mile": {
      rows: [
        [2, 4800, 4850, 4900, 4950, 5050],
        [5, 4500, 4600, 4700, 4800, 4950],
        [10, 3800, 4000, 4200, 4500, 4900],
        [25, 1600, 2000, 2500, 2900, 3700],
        [50, 600, 800, 1200, 1600, 2400],
        [100, "☠️", 200, 400, 600, 1500],
        [200, "☠️", "☠️", "☠️", "☠️", "☠️"],
      ],
    },
    "25 Mile": {
      rows: [
        [2, 4900, 4950, 5000, 5050, 5150],
        [5, 4800, 4900, 5000, 5050, 5200],
        [10, 4400, 4600, 4700, 4900, 5100],
        [25, 2800, 3200, 3600, 4000, 4700],
        [50, 1400, 1800, 2200, 2600, 3400],
        [100, 600, 800, 1200, 1600, 3200],
        [200, "☠️", "☠️", 200, 400, 1200],
      ],
    },
    "50 Mile": {
      rows: [
        [2, 4950, 5000, 5050, 5100, 5200],
        [5, 4900, 4950, 5050, 5100, 5300],
        [10, 4700, 4800, 4900, 5000, 5400],
        [25, 3800, 4200, 4600, 5000, 5800],
        [50, 2800, 3200, 3600, 4000, 4700],
        [100, 1200, 1600, 2000, 2400, 4000],
        [200, "☠️", 200, 400, 600, 1500],
      ],
    },
    "100 Mile": {
      rows: [
        [2, 5000, 5050, 5100, 5150, 5300],
        [5, 4950, 5000, 5050, 5100, 5400],
        [10, 4900, 5000, 5100, 5200, 5500],
        [25, 4600, 4800, 5000, 5200, 5800],
        [50, 4000, 4400, 4800, 5000, 5800],
        [100, 3000, 3500, 4000, 4500, 5000],
        [200, 1500, 1800, 2200, 2600, 4000],
      ],
    },
  };

  const colorMap = [
    { min: 0, max: 999, color: "#FFFF99" }, // Light yellow
    { min: 1000, max: 2599, color: "#FFCC66" }, // Light orange
    { min: 2600, max: 3599, color: "#FF9933" }, // Orange
    { min: 3600, max: 4499, color: "#FF6600" }, // Dark orange
    { min: 4500, max: Infinity, color: "#FF3300" }, // Red
  ];

  const imageMap = [
    {
      min: 0,
      max: 999,
      src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-01.png",
    },
    {
      min: 1000,
      max: 2599,
      src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-02.png",
    },
    {
      min: 2600,
      max: 3599,
      src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-03.png",
    },
    {
      min: 3600,
      max: 4499,
      src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-04.png",
    },
    {
      min: 4500,
      max: Infinity,
      src: "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-05.png",
    },
  ];

  const tableContainer = document.getElementById("heatmap-table");
  const imageDisplay = document.getElementById("image-display");
  const dropdown = document.getElementById("energizer-select");

  // Function to get color based on voltage
  function getColor(voltage) {
    for (let range of colorMap) {
      if (voltage >= range.min && voltage <= range.max) {
        return range.color;
      }
    }
    return "#FFFFFF"; // Default color (white) if no match
  }

  // Function to get image based on voltage
  function getImage(voltage) {
    for (let range of imageMap) {
      if (voltage >= range.min && voltage <= range.max) {
        return range.src;
      }
    }
    return "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-06.png"; // Skull image for unmatched values
  }

  // Function to create or update the table
  function createTable(selectedData) {
    tableContainer.innerHTML = ""; // Clear the previous table
    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.borderCollapse = "collapse";

    // Create the header row
    const headerRow = document.createElement("tr");
    const headers = ["Distance", "5 mil", "7 mil", "9 mil", "10 mil", "12 mil"];
    headers.forEach((headerText) => {
      const th = document.createElement("th");
      th.textContent = headerText;
      th.style.padding = "10px";
      th.style.textAlign = "center";
      th.style.backgroundColor = "#DFF0D8";
      th.style.border = "0px solid #ccc";
      headerRow.appendChild(th);
    });
    table.appendChild(headerRow);

    // Populate the table with the selected data
    selectedData.rows.forEach((rowData) => {
      const row = document.createElement("tr");
      rowData.forEach((cellData, index) => {
        const td = document.createElement("td");
        td.textContent = cellData;
        td.style.padding = "10px";
        td.style.textAlign = "center";
        td.style.border = "0px solid #ccc";

        // Assign color based on voltage for non-skull cells
        if (cellData !== "☠️" && !isNaN(cellData)) {
          const voltage = parseInt(cellData);
          td.style.backgroundColor = getColor(voltage);

          // Add hover and touch events to change the image
          td.addEventListener("mouseover", () => {
            imageDisplay.src = getImage(voltage);
          });
          td.addEventListener("touchstart", () => {
            imageDisplay.src = getImage(voltage);
          });
        } else if (cellData === "☠️") {
          td.style.backgroundColor = "#FFFFFF"; // Keep skull cells white
          td.style.color = "black"; // Skull symbol always visible
          td.addEventListener("mouseover", () => {
            imageDisplay.src =
              "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-06.png";
          });
          td.addEventListener("touchstart", () => {
            imageDisplay.src =
              "https://cdn.shopify.com/s/files/1/0797/6609/4017/files/image-06.png";
          });
        }

        row.appendChild(td);
      });
      table.appendChild(row);
    });

    tableContainer.appendChild(table);
  }

  // Event listener for dropdown selection
  dropdown.addEventListener("change", function () {
    const selectedOption = dropdown.value;
    const selectedData = energizerData[selectedOption];
    createTable(selectedData);
  });

  // Initialize with the 2 Mile data
  createTable(energizerData["2 Mile"]);
});
